// Google Analytics Ecommerce

import { RECIEPT_CHECKOUT_TYPES } from "../accessibility/focus/constants";
import { getAnalyticsModalData } from "./Constants";

// This function deletes all the properties off the digitalData object that are *not* listed in the saveKeys array.
export function pruneDigitalDataObj() {
  var keys = Object.keys(window.digitalData).forEach((key) => {
    var saveKeys = ["archive", "authentication", "pageInfo", "category", "chat"];
    if (!saveKeys.find(skey => skey === key)) {
      delete window.digitalData[key];
    }
  })
}

export function getSlimcart(cart, trimInCart = true) {
  // CES has an empty cart object in checkout
  // getSlimcart was used in other places to bundle carriers and parent items together
  if(Object.keys(cart).length === 0) return [];
  const slimcart = [];
  const carrierItems = getServiceActivations(cart.cartItemsForEmail)
  if(cart.cartItemsForEmail) {
    cart.cartItemsForEmail.forEach(
      (item) => {
        const isCarrier = item.serviceType === 'CARRIER_ACTIVATION'
        if (isCarrier) return;
        const carriers = carrierItems.find(carrier => carrier.parentID === item.materialIDKeyAsInt);
        const hasCarrier = !!carriers
        const product = {
          brand: item.manufacturerName,
          category: item.categoryId,
          productSku: item.mfrPartNumber,
          insightPartId: item.materialID,
          list: "Cart", // materialType?
          name: item.description,
          price: item.price,
          quantity: item.quantity,
          ...(!!hasCarrier && carriers)
        }
        delete product.parentID;
        if (!trimInCart) {
          delete product.list;
          product.currency = item.currency;
        }
        slimcart.push(product);
      }
    );
  }
  return slimcart;
}

export function removeFromCartGAE(cart, ...cartItems) {
  pruneDigitalDataObj();
  const products = cartItems.some(Array.isArray) ? cartItems.reduce((a, b) => a.concat(b)) : cartItems // flatten
  window.dataLayer = window.dataLayer || []

  function removeFromCartRevise(tmname, obj) {
    if (tmname == "atm") {
      delete obj.ecommerce.remove.products[0].id;
    } else if (tmname == "gtm") {
      delete obj.ecommerce.remove.products[0].productSku;
      delete obj.ecommerce.remove.products[0].insightPartId;
      delete obj.cart;
    }
    return obj;
  };
  const slimCart = getSlimcart(cart);
  if(!!products[0].serviceType) {
    delete products[0].contractID
    delete products[0].materialID
  }

  // report on data to Analytics tools.
  const remove_from_cart = {
    event: 'removeFromCart',
    scEvent: 'scRemove', // atm
    ecommerce: {
      remove: {
        products: products,
      },
    },
    cart: slimCart,
  }
  //window.dataLayer.push(remove_from_cart)
  fireTagEvent('removeFromCart', remove_from_cart, removeFromCartRevise);
}
export function addToCartGAE(cart, items,isAccessoryModal) {
  if (items.length === 0) return;
  pruneDigitalDataObj();
  window.dataLayer = window.dataLayer || []
  const trackEvent = !!items[0].previousCarrier && items[0].carrier !== items[0].previousCarrier ? 'update' : 'add'
  function addToCartRevise(tmname, obj) {
    if (tmname == "atm") {
      delete obj.ecommerce[trackEvent].products[0].id;
    } else if (tmname == "gtm") {
      obj.ecommerce[trackEvent].products[0].id = obj.ecommerce[trackEvent].products[0].productSku;
      delete obj.ecommerce[trackEvent].products[0].productSku;
      delete obj.ecommerce[trackEvent].products[0].insightPartId;
      delete obj.cart;
    }
    return obj;
  };
  const slimCart = getSlimcart(cart);
  if(trackEvent === 'update') {
    delete items[0].previousCarrier
  }
  if(items[0].serviceType === 'service_activation') {
    delete items[0].contractID
    delete items[0].materialID
  }
  const add_to_cart = {
    event: 'addToCart',
    ecommerce: {
      currencyCode: items[0].currency,
      [trackEvent]: {
        products: [...items],
      },
    },
    cart: slimCart,
    modal: getAnalyticsModalData(isAccessoryModal)
  }
  fireTagEvent('addToCart', add_to_cart, addToCartRevise);
}
export function checkoutGAE(options) {
  const step = options.step;
  const cart = options.cart || {};
  const slimCart = getSlimcart(cart, false);
  const cartItems = slimCart.length ? slimCart : options.cartItems;
  const isSaveAsQuote = options.isSaveAsQuote;
  const isOrderTemplate = options.isOrderTemplate;
  const isQuickCheckout = options.isQuickCheckout;
  const overridePageTitle = options.overridePageTitle;
  const overrides = {
    pageTitle: overridePageTitle
  }
  window.dataLayer = window.dataLayer || []
  pruneDigitalDataObj();
  $.when(window.InsightUserObject.ready()).done((userObject) => {
    DataLayerObject.setDataLayer(userObject, overrides);
  });

  function checkoutRevise(tmname, obj) {
    if (tmname == "gtm") {
      var products = obj.ecommerce.checkout.products;
      for (let i = 0; i < products.length; i++) {
        var product = products[i];
        product.id = product.insightPartId;
        delete product.insightPartId;
        delete product.productSku;
      }
      delete obj.ecommerce.checkout.actionField.action;
      delete obj.cart;
    }
    return obj;
  };
  const checkoutEvent = {
    event: 'checkout',
    dimension24: '' + isQuickCheckout,
    ecommerce: {
      checkout: {
        subTotal: cart.subTotal,
        total: cart.totalCost,
        actionField: {
          action: "checkout",
          step: step
        },
        products: cartItems,
      },
    },
  }
  if (isSaveAsQuote) {
    checkoutEvent.ecommerce.checkout.actionField.list = 'Saved Quote'
  } else if (isOrderTemplate) {
    checkoutEvent.ecommerce.checkout.actionField.list = 'Order Template'
  }
  //    window.dataLayer.push(checkoutEvent)
  fireTagEvent('checkout', checkoutEvent, checkoutRevise);
}
export function paymentOptionsGAE(step, billingRequest) {
  const option = billingRequest.type === 1 ? 'Terms' : billingRequest.type === 2 ? 'Credit Card' : 'Procurement Card'
  checkoutOptionsGAE(step, option)
}
export function checkoutOptionsGAE(step, option) {
  window.dataLayer = window.dataLayer || []
  const checkout_option = {
    event: 'checkoutOption',
    ecommerce: {
      checkout: {
        actionField: {
          step: step,
          option: option
        },
      },
    },
  }
  //    window.dataLayer.push(checkout_option)
  fireTagEvent('checkoutOption', checkout_option);
}

 
const checkIfNotRequisition = (checkoutType) => {
  return !checkoutType || ![RECIEPT_CHECKOUT_TYPES.REQUISITION_APPROVED, RECIEPT_CHECKOUT_TYPES.REQUISITION_CHECKOUT,RECIEPT_CHECKOUT_TYPES.REQUISITION_REQUESTED].includes(checkoutType);
}
export function receiptGAE(shoppingRequest, isSaveAsQuote, isOrderTemplate, isQuickCheckout, postPurchaseCallback, checkoutType) {
  const isCheckoutTypeNotRequisition = checkIfNotRequisition(checkoutType)
  const oldProducts = []
  const products = []
  const carrierItems = getServiceActivations(shoppingRequest.cart.cartItems, true)
  shoppingRequest.cart.cartItems.forEach((item, index) => {
    const isCarrier = item.serviceType === 'CARRIER_ACTIVATION'
    const carrierItem = carrierItems.find(carrier => carrier.parentItemId === item.itemId);
    if(!!carrierItem) {
      delete carrierItem?.parentItemId;
    }
    if(isCarrier) return;
    products.push({
      insightPartId: item.materialInfo.materialId,
      productSku: item.materialInfo.manufacturerPartNumber,
      name: item.materialInfo.description,
      category: item.materialInfo.categoryId,
      price: item.materialInfo.unitPrice,
      quantity: item.quantity,
      brand: item.materialInfo.manufacturerName,
      ...(!!carrierItem && carrierItem)
    })
    oldProducts.push({
      id: item.materialInfo.materialId,
      name: item.materialInfo.description,
      category: item.materialInfo.categoryId,
      price: item.materialInfo.unitPrice,
      quantity: item.quantity,
      brand: item.materialInfo.manufacturerName,
      ...(!!carrierItem && carrierItem)
    })
    if (item.warranty) {
      // we have warranty Item to add
      const {
        materialId,
        description,
        unitPrice,
        quantity,
        manufacturerName,
        manufacturerPartNumber
      } = item.warranty
      products.push({
        insightPartId: materialId,
        productSku: manufacturerPartNumber,
        brand: manufacturerName,
        name: description,
        category: null,
        price: unitPrice,
        quantity: quantity,
      })
      oldProducts.push({
        id: materialId,
        brand: manufacturerName,
        name: description,
        category: null,
        price: unitPrice,
        quantity: quantity,
      })
    }
  })

  const {
    taxCost = 0, pstTaxCost = 0, gstHstTaxCost = 0
  } = shoppingRequest.cart.summary;
  //  New purchase event
  const purchaseEvent = {
    ecommerce: {
      event: isCheckoutTypeNotRequisition ? 'checkout' : { eventName: "approverActionYes" },
      scEvent: 'purchase',
      cartId: shoppingRequest.salesDocumentNumber, // Transaction ID. Required for purchases and refunds.
      coupon: '',
      currencyCode: shoppingRequest.soldTo.currency,
      purchaseId: shoppingRequest.webReferenceNumber,
      total: shoppingRequest.cart.summary.totalCost,
      subTotal: shoppingRequest.cart.summary.subTotal,
      //revenue: shoppingRequest.cart.summary.totalCost,
      //discountApplied: shoppingRequest.cart.summary.
      shipping: shoppingRequest.cart.summary.shippingCost,
      tax: taxCost + pstTaxCost + gstHstTaxCost,
      //techDeal
      actionField: {
        affiliation: 'Insight.com', // The store or affiliation from which this transaction occurred, Adjust as needed
      },
      products: products,
    }
  }
  if(isCheckoutTypeNotRequisition) {
     purchaseEvent.ecommerce.dimension24 =  '' + isQuickCheckout
     purchaseEvent.ecommerce.actionField.step = 6
  }

  if(checkoutType) {
    purchaseEvent.ecommerce.checkoutType = checkoutType
  }
  if (!!shoppingRequest.billing.payment) {
    purchaseEvent.ecommerce.paymentMethod = shoppingRequest.billing.payment.type
  }
  if (!!shoppingRequest.shipping.carrier) {
    // software items may not have carrier information
    purchaseEvent.ecommerce.shippingMethod = shoppingRequest.shipping.carrier.description
  }
  if (isSaveAsQuote) {
    purchaseEvent.ecommerce.actionField.list = 'Saved Quote'
  } else if (isOrderTemplate) {
    purchaseEvent.ecommerce.actionField.list = 'Order Template'
  }
  fireTagEvent('purchase', purchaseEvent);

  // Test to assure script hasn't been adblocked, then Force "Purchase" to be read synchronously
  window["_satellite"] && _satellite.track && _satellite.track("Purchase");

  window.dataLayer = window.dataLayer || []
  const oldPurchaseEvent = {
    event: 'checkout',
    dimension24: '' + isQuickCheckout,
    ecommerce: {
      purchase: {
        actionField: {
          step: 6,
          affiliation: 'Insight.com', // The store or affiliation from which this transaction occurred, Adjust as needed
          id: shoppingRequest.webReferenceNumber, // Transaction ID. Required for purchases and refunds.
          revenue: shoppingRequest.cart.summary.totalCost,
          tax: taxCost + pstTaxCost + gstHstTaxCost,
          shipping: shoppingRequest.cart.summary.shippingCost,
          coupon: '',
        },
        products: oldProducts,
      },
    },
  }
  if (!!postPurchaseCallback) {
    oldPurchaseEvent.eventCallback = postPurchaseCallback;
  }

  if (isSaveAsQuote) {
    oldPurchaseEvent.ecommerce.purchase.actionField.list = 'Saved Quote'
  } else if (isOrderTemplate) {
    oldPurchaseEvent.ecommerce.purchase.actionField.list = 'Order Template'
  }
  //    window.dataLayer.push(purchaseEvent)
  fireTagEvent('oldPurchase', oldPurchaseEvent);

}
export function productOnClickGAE(product, productUrl, listName, position = 0) {

  window.dataLayer = window.dataLayer || []
  const product_click = {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: listName
        },
        products: [{
          name: product.description,
          id: product.materialID,
          price: product.price,
          brand: product.manufacturerName,
          category: product.categoryId,
          position: position,
        }],
      },
    },
    eventCallback: function() {
      document.location = productUrl
    }
  }
  //    window.dataLayer.push(product_click)
  fireTagEvent('productClick', product_click);
}
export function processCartUpdatesGAE(newCart, oldCart, updates) {
  const oldContracts = oldCart.contracts;
  const updatedCartItems = updates.map((update) => {
    const updatedItem = oldContracts[update?.contractID]?.cartItems[update?.materialID]
    const isCarrierActivation = updatedItem?.serviceType === 'CARRIER_ACTIVATION'
    const updateItemCarrier = updatedItem?.hasCarrierActivation ? getServiceActivations([updatedItem?.carrierActivation]) : null
    if(updateItemCarrier) {
      delete updateItemCarrier[0]?.parentID
    }
    if(isCarrierActivation) return;
    return {
      name: updatedItem?.description,
      id: updatedItem?.materialID,
      productSku: updatedItem?.mfrPartNumber,
      insightPartId: updatedItem?.materialID,
      price: updatedItem?.price,
      brand: updatedItem?.manufacturerName,
      category: updatedItem?.categoryId,
      quantity: update.quantity - updatedItem?.quantity,
      currency: updatedItem?.currency,
      ...(!!updateItemCarrier && updateItemCarrier[0]),
    }
    
  })
  updatedCartItems.forEach((item) => {
    if (item.quantity < 0) {
      item.quantity = Math.abs(item.quantity)
      removeFromCartGAE(oldCart, item)
    } else {
      addToCartGAE(oldCart, [item])
    }
  })
  processCartGAE(newCart);
}
export function processCartGAE(pcart) {
  // report on data to Analytics tools.
  const carrierItems = getServiceActivations(pcart.cartItemsForEmail)
  const products = pcart.cartItemsForEmail.map(
    (item) => {
      const isCarrier = item.serviceType === 'CARRIER_ACTIVATION'

      if(isCarrier) return;

      const hasCarrier = carrierItems.find(carrier => carrier.parentID === item.materialIDKeyAsInt);
      const product = {
        brand: item.manufacturerName,
        category: item.categoryId,
        productSku: item.mfrPartNumber,
        insightPartId: item.materialID,
        list: "Cart", // materialType?
        name: item.description,
        price: item.price,
        quantity: item.quantity,
        ...(!!hasCarrier && hasCarrier)
      }
      delete product.parentID;
      return product;
    }
  ).filter(item => !!item); // filter out undefined items
  const cart = {
    ecommerce: {
      scEvent: "scOpen",
      subTotal: pcart.subTotal,
      total: pcart.totalCost,
      currencyCode: pcart.currency,
      products: products
    }
  }
  fireTagEvent("cart", cart);
}
export function pdpGAE(item) {
  if (!item || !item.price) return;
  const product = {
    ecommerce: {
      scEvent: "prodView",
      currencyCode: item.currency,
      productInfo: {
        brand: item.brand,
        category: item.category,
        productSku: item.manufacturerPartNumber,
        insightPartId: item.materialId,
        name: item.description,
        price: item.price,
        pdpTabs: item.tab || '',
        variant: item.variant || '',
        variantCategory: item.variantCategory || '',
        variantSubCategory: item.variantSubCategory || '',
      }
    }
  }

  fireTagEvent("pdp", product);
}

export const getServiceActivations = (cart, isPurchase = false) => {
  const serviceActivations = cart?.filter(item => item.serviceType === 'CARRIER_ACTIVATION') || []
  if (serviceActivations.length === 0) return [];
  if(!!serviceActivations[0]?.materialInfo && isPurchase){
    return serviceActivations.map(item => ({
      parentItemId: item.parentItemId,
      carrierName: item.materialInfo?.description,
      carrierProductSku: item.materialInfo?.manufacturerPartNumber,
      carrierInsightPartId: item.materialInfo?.materialId,
      carrierPrice: item.materialInfo?.unitPrice,
      carrierBrand: item.materialInfo?.manufacturerName,
      carrierCategoryType: 'Carrier Activation',
      carrierServiceType: item.materialInfo?.manufacturerName,
    }))
  }
  return serviceActivations.map(item => ({
    carrierName: item.description,
    carrierProductSku: item.mfrPartNumber,
    carrierInsightPartId: item.materialID,
    carrierPrice: item.price,
    carrierBrand: item.manufacturerName,
    carrierCategoryType: 'Carrier Activation',
    carrierServiceType: item.manufacturerName,
    parentID: item.parentMaterialId
  }));
}
